/**
 * @description Ad setup definition. Replaces avia AdContext so we can differentiate IMA, DAI SDK, DAI SBB, DAI API, NONE
 */
export enum AdSetupDefinition {

	/**
	 * @description IMA
	 */
	IMA = 'ima',

	/**
	 * @description DAI SDK
	 */
	DAI_SDK = 'dai_sdk',

	/**
	 * @description DAI SSB
	 */
	DAI_SSB = 'dai_ssb',

	/**
	 * @description DAI API
	 */
	DAI_API = 'dai_api',

	/**
	 * @description Linear ad tracking - does not require SDK
	 */
	LINEAR_AD_TRACKING = 'linear_ad_tracking',

	/**
	 * @description Stitcher SSAI - FAST (Free Ad-Supported Streaming) for Pluto TV. Does not require SDK.
	 */
	STITCHER = 'stitcher',

	/**
	 * @description No ad setup required
	 */
	NONE = 'none'

}